/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  PhotoType,
  ValidateMatchPhotoResponse,
  ValidateQuestPhotoFailResponse,
  ValidateQuestPhotoSuccessResponse,
  ValidateSocialPostBody,
  ValidateSocialPostFailResponse,
  ValidateSocialPostSuccessResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    PhotoTypeFromJSON,
    PhotoTypeToJSON,
    ValidateMatchPhotoResponseFromJSON,
    ValidateMatchPhotoResponseToJSON,
    ValidateQuestPhotoFailResponseFromJSON,
    ValidateQuestPhotoFailResponseToJSON,
    ValidateQuestPhotoSuccessResponseFromJSON,
    ValidateQuestPhotoSuccessResponseToJSON,
    ValidateSocialPostBodyFromJSON,
    ValidateSocialPostBodyToJSON,
    ValidateSocialPostFailResponseFromJSON,
    ValidateSocialPostFailResponseToJSON,
    ValidateSocialPostSuccessResponseFromJSON,
    ValidateSocialPostSuccessResponseToJSON,
} from '../models/index';

export interface CreateEventPipelineValidateMatchPhotoRequest {
    photo: Blob;
    gameName: string;
    overwolfGameId?: string;
    matchId?: string;
}

export interface CreateEventPipelineValidateQuestPhotoRequest {
    photo: Blob;
    photoType?: PhotoType;
    eventTypeId?: string;
    testMode?: string;
}

export interface CreateEventPipelineValidateSocialPostRequest {
    validateSocialPostBody: ValidateSocialPostBody;
}

/**
 * ObjectivesApi - interface
 * 
 * @export
 * @interface ObjectivesApiInterface
 */
export interface ObjectivesApiInterface {
    /**
     * Stores a game match photo. For tournament participants the photo is attached to their live bracket match as evidence for later dispute adjudication — it is never analyzed or scored at upload.
     * @param {Blob} photo The photo file to validate
     * @param {string} gameName The name of the game
     * @param {string} [overwolfGameId] The overwolf game ID
     * @param {string} [matchId] If we require the players to display a unique identifier in the screenshot to prove they are in the correct match.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectivesApiInterface
     */
    createEventPipelineValidateMatchPhotoRaw(requestParameters: CreateEventPipelineValidateMatchPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateMatchPhotoResponse>>;

    /**
     * Stores a game match photo. For tournament participants the photo is attached to their live bracket match as evidence for later dispute adjudication — it is never analyzed or scored at upload.
     */
    createEventPipelineValidateMatchPhoto(requestParameters: CreateEventPipelineValidateMatchPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateMatchPhotoResponse>;

    /**
     * Validates an objective photo and creates an asset if valid
     * @param {Blob} photo The photo file to validate
     * @param {PhotoType} [photoType] The type of vehicle in the photo. Required if &#x60;eventTypeId&#x60; is not provided.
     * @param {string} [eventTypeId] Alternative to photoType — when provided, the route resolves photoType from the EventType\&#39;s &#x60;fields.devourPhotoType.options[0]&#x60;. Data-driven entry path for Brand Challenge hubs whose objectives carry triggerEvent.eventTypeId.
     * @param {string} [testMode] When \&quot;true\&quot;, bypasses the per-user failed-submission cap (GOD_ADMIN only).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectivesApiInterface
     */
    createEventPipelineValidateQuestPhotoRaw(requestParameters: CreateEventPipelineValidateQuestPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateQuestPhotoSuccessResponse>>;

    /**
     * Validates an objective photo and creates an asset if valid
     */
    createEventPipelineValidateQuestPhoto(requestParameters: CreateEventPipelineValidateQuestPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateQuestPhotoSuccessResponse>;

    /**
     * Verify a user-submitted social post URL against a campaign hashtag and emit progression events on success.
     * @param {ValidateSocialPostBody} validateSocialPostBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectivesApiInterface
     */
    createEventPipelineValidateSocialPostRaw(requestParameters: CreateEventPipelineValidateSocialPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateSocialPostSuccessResponse>>;

    /**
     * Verify a user-submitted social post URL against a campaign hashtag and emit progression events on success.
     */
    createEventPipelineValidateSocialPost(requestParameters: CreateEventPipelineValidateSocialPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateSocialPostSuccessResponse>;

}

/**
 * 
 */
export class ObjectivesApi extends runtime.BaseAPI implements ObjectivesApiInterface {

    /**
     * Stores a game match photo. For tournament participants the photo is attached to their live bracket match as evidence for later dispute adjudication — it is never analyzed or scored at upload.
     */
    async createEventPipelineValidateMatchPhotoRaw(requestParameters: CreateEventPipelineValidateMatchPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateMatchPhotoResponse>> {
        if (requestParameters['photo'] == null) {
            throw new runtime.RequiredError(
                'photo',
                'Required parameter "photo" was null or undefined when calling createEventPipelineValidateMatchPhoto().'
            );
        }

        if (requestParameters['gameName'] == null) {
            throw new runtime.RequiredError(
                'gameName',
                'Required parameter "gameName" was null or undefined when calling createEventPipelineValidateMatchPhoto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['photo'] != null) {
            formParams.append('photo', requestParameters['photo'] as any);
        }

        if (requestParameters['gameName'] != null) {
            formParams.append('gameName', requestParameters['gameName'] as any);
        }

        if (requestParameters['overwolfGameId'] != null) {
            formParams.append('overwolfGameId', requestParameters['overwolfGameId'] as any);
        }

        if (requestParameters['matchId'] != null) {
            formParams.append('matchId', requestParameters['matchId'] as any);
        }


        let urlPath = `/event-pipeline/validate-match-photo`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateMatchPhotoResponseFromJSON(jsonValue));
    }

    /**
     * Stores a game match photo. For tournament participants the photo is attached to their live bracket match as evidence for later dispute adjudication — it is never analyzed or scored at upload.
     */
    async createEventPipelineValidateMatchPhoto(requestParameters: CreateEventPipelineValidateMatchPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateMatchPhotoResponse> {
        const response = await this.createEventPipelineValidateMatchPhotoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validates an objective photo and creates an asset if valid
     */
    async createEventPipelineValidateQuestPhotoRaw(requestParameters: CreateEventPipelineValidateQuestPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateQuestPhotoSuccessResponse>> {
        if (requestParameters['photo'] == null) {
            throw new runtime.RequiredError(
                'photo',
                'Required parameter "photo" was null or undefined when calling createEventPipelineValidateQuestPhoto().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['photoType'] != null) {
            queryParameters['photoType'] = requestParameters['photoType'];
        }

        if (requestParameters['eventTypeId'] != null) {
            queryParameters['eventTypeId'] = requestParameters['eventTypeId'];
        }

        if (requestParameters['testMode'] != null) {
            queryParameters['testMode'] = requestParameters['testMode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['photo'] != null) {
            formParams.append('photo', requestParameters['photo'] as any);
        }


        let urlPath = `/event-pipeline/validate-quest-photo`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateQuestPhotoSuccessResponseFromJSON(jsonValue));
    }

    /**
     * Validates an objective photo and creates an asset if valid
     */
    async createEventPipelineValidateQuestPhoto(requestParameters: CreateEventPipelineValidateQuestPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateQuestPhotoSuccessResponse> {
        const response = await this.createEventPipelineValidateQuestPhotoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verify a user-submitted social post URL against a campaign hashtag and emit progression events on success.
     */
    async createEventPipelineValidateSocialPostRaw(requestParameters: CreateEventPipelineValidateSocialPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateSocialPostSuccessResponse>> {
        if (requestParameters['validateSocialPostBody'] == null) {
            throw new runtime.RequiredError(
                'validateSocialPostBody',
                'Required parameter "validateSocialPostBody" was null or undefined when calling createEventPipelineValidateSocialPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/event-pipeline/validate-social-post`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateSocialPostBodyToJSON(requestParameters['validateSocialPostBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateSocialPostSuccessResponseFromJSON(jsonValue));
    }

    /**
     * Verify a user-submitted social post URL against a campaign hashtag and emit progression events on success.
     */
    async createEventPipelineValidateSocialPost(requestParameters: CreateEventPipelineValidateSocialPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateSocialPostSuccessResponse> {
        const response = await this.createEventPipelineValidateSocialPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
